import { gql } from '@apollo/client';

const USER_FRAGMENT = gql`
  fragment BaseUser on User {
    id
    username
    firstName
    lastName
    type
    pin
    avatarUrl
    status
    dateUpdated
    sisId
  }
`;

export default USER_FRAGMENT;
